import React, { ReactElement } from 'react';
import { useTheme } from '../ThemeProvider';
import AppNameBannerStyle from './AppNameBannerStyle';

export default function AppNameBanner({
  title,
  portalUrl
}: {
  title: string;
  portalUrl: string;
}): ReactElement {
  const { isDarkMode } = useTheme();
  const { styles, cx, theme } = AppNameBannerStyle({ isDarkMode });

  return (
    <div className={cx(styles.appNameBannerStyle)}>
      <a href={portalUrl}>
        <img src={`/shield-${isDarkMode ? 'dark' : 'light'}.svg`} alt="shield" />
      </a>
      <div className="title-container">
        <a href="/">
          {title.split(' ').map((s, i) => (
            <div key={i} className="title second">
              {s}
            </div>
          ))}
        </a>
      </div>
    </div>
  );
}
